import { MemberService } from '../../Services/member.service';
import { CourseService } from '../../Services/course.service';
import { GroupService } from '../../Services/group.service';
import { CourseriddenService } from '../../Services/courseridden.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IMyDpOptions, IMyMarkedDate, IMyDayLabels } from 'mydatepicker';
import { LifecycleHooks } from '@angular/compiler/src/lifecycle_reflector';
import Swal from 'sweetalert2';
import { AuthService } from '../../Services/auth.service';
import { CalendarCreatorFormComponent } from '../calendar-creator-form/calendar-creator-form.component';
import { CalendarService } from '../../Services/calendar.service';
import { flatMap } from 'lodash';

@Component({
  selector: 'app-courseridden-form',
  template: require('./courseridden-form.component.html'),
  styles: [require('./courseridden-form.component.css')]
})
export class CourseriddenFormComponent implements OnInit {

  courseRidden: any = {
    id: 0,
    courseId: 0,
    distance: 0,
    altitudeMeters: 0,
    groupId: 0,
    courseMembers: []
  };

  racefietsType = 1;
  mtbGravelFietsType  = 2;
  vakantiesType = 3

  groups: any[] = [];
  courses: any[] = [];
  members: any[] = [];
  selectedMembersCount: number = 0;
   
  selectedDate: any;
  myDatePickerOptions: IMyDpOptions = {
    todayBtnTxt: 'Vandaag',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    markCurrentDay: true,
    height: '34px',
    width: '210px',
    alignSelectorRight: false,
    openSelectorTopOfInput: false,
    indicateInvalidDate: true,
    monthSelector: true,
    yearSelector: true,
    minYear: 1920,
    maxYear: 2200,
    componentDisabled: false,
    editableDateField:false,
    showClearDateBtn: true,
    showDecreaseDateBtn: false,
    showIncreaseDateBtn: false,
    showSelectorArrow: true,
    showInputField: true,
    openSelectorOnInputClick: false,
    disableHeaderButtons: true,
    showWeekNumbers: false,
    markDates: [],
    satHighlight: false,
    highlightDates: [],
    markWeekends: <IMyMarkedDate>{},
    monthLabels: {
        1: 'Januari',
        2: 'Februari',
        3: 'Maart',
        4: 'April',
        5: 'Mei',
        6: 'Juni',
        7: 'July',
        8: 'Augustus',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'December'
    },
    dayLabels: <IMyDayLabels>{
      su: 'zo', mo: 'ma', tu: 'di', we: 'wo', th: 'do', fr: 'vr', sa: 'za'
    },
    allowDeselectDate: true,
    disableWeekdays: [],
    allowSelectionOnlyInCurrentMonth: true
  };

  nameSearchString: string = '';
  searched_members: any[] = [];


  selected_members:any[] = [];
  showOnlySelected: boolean = false;
  showOnlyGroup:boolean = false;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private coursesRiddenService: CourseriddenService,
    private groupService: GroupService,
    private courseService: CourseService,
    private memberService: MemberService,
    private calendarService: CalendarService,
    private auth: AuthService) {

    route.params.subscribe(p => {
      if (p['id'])
        this.courseRidden.id = +p['id'];
      else
        this.courseRidden.id = 0;
    });
  }

  ngOnInit() {
    if (this.courseRidden.id > 0) {
      this.coursesRiddenService.getCourseRidden(this.courseRidden.id).subscribe(
        cr => {
          this.courseRidden = cr;
          
          this.courseRidden.courseMembers.forEach( (e :any ) => {
            this.selected_members.push(e.member.id);
          });
          
          var d = new Date(this.courseRidden.date);
          this.selectedDate = {
            jsdate: d,
            date:{year: d.getFullYear(), month: d.getMonth() +1, day: d.getDate()}
          };   
          
          // console.log("ngOninit: ", this.courseRidden);
          // this.refreshCourses()
          
        }, err => {
          if (err.status == 404)
            this.router.navigate(['/home']);
            console.log(err);
            console.log(this.courseRidden.id);
        });
    }

    this.groupService.getGroupNames(true).subscribe(g => {
      this.groups = g
    });

    var d = new Date();
    this.selectedDate = {
      jsdate: d,
      date:{year: d.getFullYear(), month: d.getMonth() +1, day: d.getDate()}
    };   

    this.courseService.getCoursesbyType(this.racefietsType).subscribe(c => {
      this.courses = c;
    });
  }
  
  removeMember(id: number) {
    // console.log("remove Member: " + id);
    var index = this.courseRidden.courseMembers.findIndex((m: any) => m.memberId === id);
    this.courseRidden.courseMembers.splice(index, 1);
  }

  // testButton(){
  //   console.log(this.selectedDate);
  // }

  submit() {
    // console.log('Submit button pressed');
    var memberIds: number[] = [];

    this.courseRidden.courseMembers.forEach((item: any) => {
      memberIds.push(item.memberId)
    });

    if (this.courseRidden.id) {
      var objectToSend = {
        "id": this.courseRidden.id,
        "CourseId": this.courseRidden.courseId,
        "Distance": String(this.courseRidden.distance).replace(',','.'),
        "Average": String(this.courseRidden.average).replace(',','.'),
        "AltitudeMeters":String(this.courseRidden.altitudeMeters).replace(',','.'),
        "GroupId": this.courseRidden.groupId,
        "Date": String(this.selectedDate.date.year)+"-"+String(this.selectedDate.date.month)+"-"+String(this.selectedDate.date.day),
        // "Date": this.courseRidden.date,
        "courseMembers": memberIds
      }
      // console.log(objectToSend);
      // console.log(this.selectedDate);

      this.coursesRiddenService.update(objectToSend).subscribe(x => {
        // console.log(x);
        // console.log("update is done");
        this.router.navigate(["/coursesridden/list"]);
      });
    }
    else {
      var newObjectToSend = {
        "CourseId": this.courseRidden.courseId,
        "Distance": String(this.courseRidden.distance).replace(',','.'),
        "Average": String(this.courseRidden.average).replace(',','.'),
        "AltitudeMeters":String(this.courseRidden.altitudeMeters).replace(',','.'),
        "GroupId": this.courseRidden.groupId,
        "Date":String(this.selectedDate.date.year)+"-"+String(this.selectedDate.date.month)+"-"+String(this.selectedDate.date.day),
        "courseMembers": memberIds
      }
      // console.log(newObjectToSend);
      this.coursesRiddenService.create(newObjectToSend).subscribe(x => {
        // console.log(x);
        // console.log("save is done");
        this.router.navigate(["/coursesridden/list"]);
      });
    }

  }

  addMember() {
    // var checks = document.getElementsByName("userchecks");
    // var addedMembers: any = [];

    // for (let i = 0; i < checks.length; i++) {
    //   const element = (<HTMLInputElement>checks[i]);
    //   if (element.checked === true) {

    //     var index = this.courseRidden.courseMembers.findIndex((m: any) => m.memberId == element.value);

    //     // console.log(index);
    //     if (index === -1) {
    //       addedMembers.push(element.value)
    //     }

    //   }
    // }
    
    this.courseRidden.courseMembers = [];

    this.selected_members.forEach((id: number) => {
      var member = this.members.find(m => m.id == id);
      var courseRiddenMember = {
        "courseRiddenId": this.courseRidden.id,
        "member": member,
        "memberId": member.id
      }
     
      this.courseRidden.courseMembers.push(courseRiddenMember);
    });
    // console.log(this.courseRidden.courMembers);
  }

  loadAllMembers() {
    this.clearSearch()
    // console.log("loading all members");
    this.memberService.getMembers().subscribe(x => {
      this.members = x;
      // console.log(this.members);
      this.selectedMembersCount =  this.selected_members.length;
      this.searched_members = this.members
    });
  }


  delete(id: number) {
    Swal.fire({
        title: 'Ben je zeker?',
        text: "Ben je zeker dat je dit wil verwijderen?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Jep',
        cancelButtonText: 'Nope'
      }).then((result) => {
        if (result.value) {
          // console.log("Delete Course Ridden id: "+id);
          this.coursesRiddenService.delete(id).subscribe(x => {
          // console.log("Delete of course ridden id: "+x);
          this.router.navigate(["/coursesridden/list"]);
        });
        }
      });
  }

  checkboxClicked(id: any) {
    // console.log("checkbox clicked:")
    // console.log(id);
    if (this.selected_members.find( x => x == id)){
      const index = this.selected_members.indexOf(id, 0);
      if (index > -1) {
        this.selected_members.splice(index, 1);
      }

    }else{
      this.selected_members.push(id);
    }
    // console.log(this.selected_members);
    this.selectedMembersCount =  this.selected_members.length
    // var count = 0;
    // var checks = document.getElementsByName("userchecks");
    // for (let i = 0; i < checks.length; i++) {
    //   const element = (<HTMLInputElement>checks[i]);
    //   if (element.checked === true) count++
    // }
    // // console.log("geselecteerden: " + count);
    // this.selectedMembers = count;
  }

  searchName(){
    // console.log('search: '+ this.nameSearchString);
    // console.log(this.members);
    if (this.nameSearchString.length > 0){
      let f = this.members.filter( (a:any)=> a.firstName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;
      let l = this.members.filter( (a:any) => a.lastName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;
      this.searched_members = f
      this.searched_members = this.searched_members.concat(l)
      // if (f.length > 0) {
      //   this.searched_members = f
      // }
      // if (l.length > 0) {
      //   this.searched_members = this.searched_members.concat(l)
      // }

      // console.log("Searched members: ");
      // this.searched_members = this.firstnames.concat(this.lastnames);
      // console.log(this.searched_members);
        
      }else{
        this.searched_members = this.members
      }
  }

  isSelected(id: any){
    if (this.selected_members.find( x => x == id)){
      return true;
    }
    else{
      return false
    }
  }

  clearSearch(){
    this.nameSearchString = '';
    this.searchName();
  }

  showRow(id: any, groupCheck: boolean){
    if (this.showOnlySelected){
      if (this.isSelected(id)){
        return true
      }else{
        return false
      }
    }
    
    if (this.showOnlyGroup){
      if (groupCheck){
        return true
      }
      else{
        return false
      }
    }

    if (!this.showOnlySelected && !this.showOnlyGroup){
      return true;
    }
  }

  refreshCourses(){
    // console.log("GroepSelectedChanged");
    // console.log("courseRidden",this.courseRidden)
    // console.log("Groups:",this.groups)
    // console.log("courses:",this.courses)
    // console.log("members:",this.members)
    // console.log("selected Date:", this.selectedDate)

    if (this.selectedDate != null){
      var group = this.groups.find(g => g.id == this.courseRidden.groupId)
      if (group != null){

        this.courseService.getCoursesbyType(group.typeBicycle).subscribe(c => {
          this.courses = c;
          
          this.calendarService.getCalendarForGroupByDate(this.courseRidden.groupId, this.selectedDate.date.day, this.selectedDate.date.month, this.selectedDate.date.year).subscribe( res =>{
            // console.log(res);
            
            if (res.status == 200){
              if (res.value.length > 0){
                var courseid = res.value[0].course.id
                // var course =  this.courses.find( c => c.id == courseid )
                // console.log("course found: ", course);
                this.courseRidden.courseId = courseid
                
              }else{
                this.courseRidden.courseId = 0;                
              }
            }
          })
        });
      }
    }else{
      this.courseRidden.courseId = 0;      
    }
  }

  GroepSelectedChanged(){
    this.refreshCourses()
  }

  onChangeDate(value: any){
    console.log("on change data");
    
    this.refreshCourses()
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/courseridden-form/courseridden-form.component.ts